import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Tooltip } from 'antd';
import { QuestionCircleOutlined, CaretRightOutlined } from "@ant-design/icons";
import {
    CLOUD_EVENT_FAILED,
    IN_QUEUE_GIF,
    NODATA,
    OPEN_HOLLAEX_DOC_APP_CREATION,
} from "../../config/media";

export const defaultLoading = { image: IN_QUEUE_GIF, time: null, level: 0, interval: 10, nextLevel: 1 };

const IframeUrl = ({ iframeData, title, subTitle, className, handleNav, exchange, iframeType }) => {

    useEffect(() => {
        window.handleGoLive = handleGoLive;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isIframe = useMemo(() => exchange.type === 'Cloud' && exchange.is_running, [exchange.type, exchange.is_running]);

    const onhandleUrl = () => {
        isIframe && window.open(iframeData, '_blank');
    }

    const handleGoLive = (type) => {
        handleNav(type);
    }

    const onhandleIframeContent = (type) => {
        const imageComponent = type === 'Cloud' ? NODATA : CLOUD_EVENT_FAILED
        return `
        <div style='height: 90vh; display: flex; flex-direction: column; align-items: center; justify-content: center; font-family: NHaasGroteskTXPro, system-ui; font-variant: tabular-nums;'>
       <img style='width:4rem; height:3rem' src=${imageComponent} alt="open-hollaex-doc-app-creation-link" className='doc-icon' />
       ${type === "Cloud" ? `<span style='color: #A8A8B1'>No Data</span>` : ''}
        <p style='color: #FFF; text-align: center;'>${(type === 'DIY' && iframeType === 'logs') ? `Logs are only available to cloud exchanges.` : (type === 'Cloud' && iframeType === 'logs') ? `To view logs your exchange must go live first.` : (type === 'Cloud' && iframeType === 'metrics') ? `To view metrics your exchange must go live first.` : `Metrics are only available to cloud exchanges.`}</p>
        <span style='color: #3A4FFF; text-decoration: underline; cursor: pointer;' onclick="window.parent.handleGoLive('${type}')">${type === 'Cloud' ? `GO LIVE` : `UPGRADE`}</span>
      </div>`
    };

    return (
        <div className={className} >
            <div className="d-flex title-wrapper">
                <span className='text-white bold title'>{title}</span>
                <div className="d-flex full-screen-wrapper" onClick={onhandleUrl}>
                    {isIframe && isIframe &&
                        <div className="d-flex">
                            <div className='view-label'>VIEW FULL SCREEN</div>
                            <img
                                src={OPEN_HOLLAEX_DOC_APP_CREATION}
                                alt="open-hollaex-doc-app-creation-link"
                                className='doc-icon'
                            />
                        </div>}
                </div>
            </div>
            <iframe
                srcDoc={!isIframe && onhandleIframeContent(exchange.type)}
                src={isIframe && iframeData}
                title={subTitle}
                height="100%"
                width="100%"
            ></iframe>
        </div >
    )
}

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
});

export default connect(mapStateToProps)(IframeUrl);

export const DashLinksToolTip = ({ renderLink }) => {

    const renderToolTip = () => {
        return (
            <div>
                <CaretRightOutlined />
                <a style={{ color: '#fff', textDecoration: 'underline' }} href={renderLink} target="_blank" without rel="noopener noreferrer">Watch video guide.</a>
            </div>
        );
    };

    return (
        <Tooltip
            placement="top"
            overlayClassName="seo-dash-link-tooltip"
            title={renderToolTip()}
        >
            <QuestionCircleOutlined />
        </Tooltip>
    );
};
